import ArtPlaceholder from "./ArtPlaceholder";
import { fmtPrice } from "../utils/format";
import { mediaSrc, isVideo } from "../utils/media";

export default function Lightbox({ item, onClose, variant }) {
  const video = isVideo(item);
  const gallery = variant === "gallery";
  const src = mediaSrc(item.img);
  const showInfo = !gallery && (item.title || item.category || item.details || item.price);

  return (
    <div className="lightbox" onClick={onClose}>
      <div className="lightbox-close" onClick={onClose}>Close ×</div>
      <div className={`lightbox-inner${gallery ? " lightbox-inner-media" : ""}`} onClick={(e) => e.stopPropagation()}>
        <div className="lightbox-img">
          {src && video ? (
            <video src={src} controls playsInline autoPlay />
          ) : src ? (
            <img src={src} alt={item.title || "Artwork"} />
          ) : (
            <ArtPlaceholder />
          )}
        </div>
        {showInfo && (
          <div className="lightbox-info">
            {item.category && <div className="lightbox-medium">{item.category}</div>}
            {item.title && <div className="lightbox-title">{item.title}</div>}
            <div className="lightbox-rule" />
            {item.price && <div className="lightbox-price">{fmtPrice(item.price)}</div>}
            {item.details && <div className="lightbox-detail">{item.details}</div>}
            <div style={{ display: "flex", gap: 12 }}>
              {item.price && <button className="btn btn-ochre">Acquire →</button>}
              <button className="btn btn-outline" onClick={onClose}>Close</button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
